<template>
  <div class="invoiceInformationList">
    <vm-table
        ref="vmTable"
        height="60vh"
        :filter.sync="filter"
        module="basic"
        url="sd/invoice/pageList">
      <template slot="adSearch">
        <vm-search label="发票日期">
          <div class="block">
            <el-date-picker
                v-model="filter.invoiceDateBegin"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.invoiceDateEnd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
        <vm-search label="发票号">
          <el-input v-model.trim="filter.invoiceNo" clearable/>
        </vm-search>
        <vm-search label="客户">
          <el-input v-model.trim="filter.customerName" clearable/>
        </vm-search>
        <vm-search label="创建日期">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateBegin"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择开始日期"/>
          </div>
        </vm-search>
        <vm-search label="至">
          <div class="block">
            <el-date-picker
                v-model="filter.createDateEnd"
                value-format="yyyy-MM-dd"
                type="date"
                style="width: 190px"
                placeholder="选择结束日期"/>
          </div>
        </vm-search>
      </template>
      <el-table-column type="expand">
        <template slot-scope="scope">
          <el-table
              :data="getTableDataDetail(scope.row)"
              style="width: 90%;margin: 0 auto">
            <el-table-column label="销售订单" prop="sapSalesOrderNo"/>
            <el-table-column label="销售行号" prop="sapSalesOrderRowIndex"/>
            <el-table-column label="发货单" prop="sapDeliveryBillNo"/>
            <el-table-column label="发货单行号" prop="sapDeliveryBillRowIndex"/>
            <el-table-column label="物料号" prop="materialNo"/>
            <el-table-column label="净价" prop="netPrice"/>
            <el-table-column label="税额" prop="taxPrice"/>
          </el-table>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceNo" label="发票号"/>
      <el-table-column align="center" prop="invoiceDate" label="发票日期">
        <template slot-scope="scope">
          <span>{{scope.row.invoiceDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
      <el-table-column align="center" prop="invoiceType" label="发票类型"/>
      <el-table-column align="center" prop="customerName" label="客户"/>
      <el-table-column align="center" prop="createDate" label="创建时间">
        <template slot-scope="scope">
          <span>{{scope.row.createDate.slice(0,10)}}</span>
        </template>
      </el-table-column>
    </vm-table>
  </div>
</template>
<script>
  import VmTable from "@/components/VmTable.vue";
  import VmSearch from "@/components/VmSearch.vue";

  export default {
    name: "InvoiceInformationList",
    components: { VmTable, VmSearch},
    data() {
      return {
        idList: "",
        filter: {
          invoiceNo: "",
          customerName: "",
          invoiceDateBegin: "",
          invoiceDateEnd: "",
          createDateBegin: "",
          createDateEnd: "",
        },
      };
    },
    mounted() {
      this.$refs.vmTable.getList(1);
    },
    methods: {
      getList(pageNum) {
        this.$refs.vmTable.getList(pageNum);
      },
      getTableDataDetail(row) {
        console.log(row);
        if(row.details==null) {
          this.$http
            .get("basic", `sd/detail/${row.pkid}`)
            .then(resp => {
              console.log(resp);
              row.details = resp.details;
            });
        }

        return row.details;
      },
    },
  };
</script>
<style lang="scss">
</style>
